import { render, staticRenderFns } from "./pay-credit-receipt.vue?vue&type=template&id=67b13d42"
import script from "./pay-credit-receipt.vue?vue&type=script&lang=js"
export * from "./pay-credit-receipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports